export const OlympicMascots = [
  {
    name: 'Beijing 2022',
    image: require('assets/images/olympics/bingDwenDwen.png'),
    title: 'Bing Dwen Dwen',
    width: 160,
    height: 188,
    sSlug: 'https://www.oneturf.news/olympics/all-about-the-2022-olympic-games-mascot'
  },
  {
    name: 'Tokyo 2020',
    image: require('assets/images/olympics/miraitowa.png'),
    title: 'Miraitowa',
    width: 162,
    height: 188,
    sSlug: 'https://www.oneturf.news/olympics/all-about-2020-summer-olympics-mascot'
  },
  {
    name: 'Pyeongchang 2018',
    image: require('assets/images/olympics/soohorang.png'),
    title: 'Soohorang',
    width: 162,
    height: 188,
    sSlug: 'https://www.oneturf.news/olympics/all-about-the-2018-olympic-games-mascot'
  },
  {
    name: 'Rio de Janeiro 2016',
    image: require('assets/images/olympics/vinicius.png'),
    title: 'Vinicius',
    width: 162,
    height: 188,
    sSlug: 'https://www.oneturf.news/olympics/all-about-2016-summer-olympics-mascot'
  },
  {
    name: 'Sochi 2014',
    image: require('assets/images/olympics/harePolarBearLeopard.png'),
    title: 'Hare, Polar Bear, and Leopard',
    width: 204,
    height: 188,
    sSlug: 'https://www.oneturf.news/olympics/all-about-the-2014-olympic-games-mascot'
  }
]
